import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

import Table from "../../../components/common/Table";
import Pagination from "../../../components/common/Pagination";
import Toaster from "../../../components/common/Toaster";

import complianceService from "../../../services/complianceService";
import moment from "moment";

const CorTable = ({ id, data, columns, tableOptions, setData, onChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await complianceService.getAccountCORsAsync(
          id,
          tableOptions
        );

        const { result, page, total_count } = response;

        const cors = result.map((item) => {
          const status_color =
            item.status === 1 ? "bg-green-400" : "bg-gray-400";

          item["date_generated_value"] = item.date_generated;
          item["status_type_value"] = item.status_type;
          item["ocn_value"] = item.ocn;

          item["date_generated"] = moment(item.date_generated).format("LL");

          item["ocn"] = (
            <div className="text-sm">
              <div>
                <Link
                  className="text-gray-500 hover:text-blue-500"
                  to={`/certificate-of-registrations/${item.id}`}
                >
                  {item.ocn}
                </Link>
              </div>
              <span className="text-gray-400 text-xs">
                {item.is_main_branch ? "Main" : "Branch"}
              </span>
            </div>
          );

          item["status_type"] = (
            <div className="flex items-center">
              <div
                className={`rounded-full h-2 w-2 flex items-center justify-center ${status_color}`}
              />
              <span className="ml-3">{item.status_type}</span>
            </div>
          );

          return item;
        });

        if (mounted) {
          setData(cors);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [id, tableOptions, setData]
  );

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  useEffect(() => {
    let mounted = true;

    fetchData(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchData]);

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={data}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default CorTable;
